import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { formatApiErrorDetail } from "@/lib/api";
import { BriefDocument } from "@/components/BriefDocument";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Printer, ShieldCheck, Loader2 } from "lucide-react";

export default function PublicBrief() {
  const { token } = useParams();
  const { t } = useTranslation();
  const [brief, setBrief] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/public/brief/${token}`)
      .then((r) => setBrief(r.data))
      .catch((e) =>
        setError(formatApiErrorDetail(e.response?.data?.detail) || t("publicBrief.gone"))
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-secondary/40 px-6 text-center">
        <Logo align="col" showSubtitle subtitle={t("auth.overline")} size={48} />
        <p className="mt-8 max-w-sm text-sm text-muted-foreground" data-testid="public-brief-error">
          {error}
        </p>
      </div>
    );
  }

  if (!brief) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-secondary/40">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-secondary/40 py-10">
      <div className="mx-auto max-w-3xl px-6">
        <div className="mb-6 flex items-center justify-between print:hidden">
          <Logo showSubtitle subtitle={t("auth.overline")} />
          <Button
            className="bg-primary text-primary-foreground hover:opacity-90"
            onClick={() => window.print()}
            data-testid="public-print-btn"
          >
            <Printer className="mr-1.5 h-4 w-4" /> {t("export.print")}
          </Button>
        </div>

        <BriefDocument brief={brief} testId="public-brief" />

        <div className="mt-6 flex items-center justify-center gap-1.5 text-xs text-muted-foreground print:hidden">
          <ShieldCheck className="h-3.5 w-3.5 text-primary" />
          {t("publicBrief.generatedByOrkeva")}
        </div>
      </div>
    </div>
  );
}
